/**
 * 计算会员周期日期范围
 * @param cycleStartDate 周期开始日期（YYYY-MM-DD）
 */
export function getCycleDateRange(
  cycleStartDate: string
): { startLabel: string; endLabel: string; nextResetDate: string } | null {
  if (!cycleStartDate) return null;

  const startDate = new Date(cycleStartDate);
  if (Number.isNaN(startDate.getTime())) return null;

  // 一个周期 30 天，结束日为开始日 + 29 天
  const endDate = new Date(startDate.getTime());
  endDate.setDate(endDate.getDate() + 29);

  // 下次重置是结束日的下一天
  const nextReset = new Date(endDate.getTime());
  nextReset.setDate(nextReset.getDate() + 1);

  const formatDate = (date: Date): string => {
    const month = date.getMonth() + 1;
    const day = date.getDate();
    return `${month}月${day}日`;
  };

  return {
    startLabel: formatDate(startDate),
    endLabel: formatDate(endDate),
    nextResetDate: formatDate(nextReset),
  };
}
